import store from '@/stores';

const getSEO = () => ({
  NAME: store.state?.theme?.theme?.business?.name || 'Prata Digital',
  IMG: '',
  DIVIDER: ' | ',
  PATH: window.location.pathname,
  HOST: window.location.host,
});

/**
 * Cria um objeto com metadados para o SEO da página
 * @param {object} data Metadados primários
 * @returns {object} Metadados
 */
const meta = (data = {}) => {
  const seo = getSEO();

  const metadata = {
    title: `${data.title ? data.title : ''}`,
    titleTemplate: `${data.title ? `%s${ seo.DIVIDER }${seo.NAME}` : seo.NAME}`,

    meta: [
      // Default
      ...(data.description ? { name: 'description', content: data.description } : ''),

      // OpenGraph data (Most widely used)
      { property: 'og:title', content: `${data.title ? data.title + seo.DIVIDER + seo.NAME : seo.NAME}` },
      { property: 'og:site_name', content: `${seo.NAME}` },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: `${seo.HOST}${seo.PATH}` },
      ...(seo.IMG ? { property: 'og:image', content: `${seo.HOST}${seo.IMG}` } : ''),
      ...(data.description ? { property: 'og:description', content: data.description } : ''),

      // Twitter card
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: `${seo.HOST}` },
      { name: 'twitter:title', content: `${data.title ? data.title + seo.DIVIDER + seo.NAME : seo.NAME}` },
      ...(data.description ? { name: 'twitter:description', content: data.description } : ''),

      // Google / Schema.org markup
      { itemprop: 'name', content: `${data.title ? data.title + seo.DIVIDER + seo.NAME : seo.NAME}` },
      ...(data.description ? { itemprop: 'description', content: data.description } : ''),
      ...(seo.IMG ? { itemprop: 'image', content: `${seo.HOST}${seo.IMG}` } : ''),
    ],
  };

  if (data.noindex) {
    const name = 'robots';
    const content = 'noindex, nofollow, noarchive, nosnippet, noodp';

    metadata.meta.push({ name, content });
  }

  return metadata;
};

export default {
  meta,
};
